<template>
  <div class="loading-wrap">
    <div>
      <img src="../assets/images/img-error02.png" alt="에러 페이지 아이콘" class="img-error02" />
    </div>
    <p class="loading-tit">서비스 점검 중입니다.</p>
    <p class="loading-text">잠시만 기다려 주세요.<br/>예상시간 : {{count}} 초</p>
    <div class="loading-spinner-wrap">
      <span class="loading-spinner rotate"></span>
    </div>
  </div>
</template>
<script>
// (getServiceLocation 제거 이후) 미사용 페이지
export default {
  name: 'waitingService',
  data () {
    return {
      defaultCount: 60,
      count: 60,
      countTimer: null
    }
  },
  created () {
    this.$router.replace('/')
  }
}
</script>

<style scoped>
  .loading-wrap{
    padding: 70px 20px;
    text-align: center;
  }

  .loading-wrap .img-error02{
    display: block;
    width: 92px;
    margin: 0 auto 40px;
  }

  .loading-tit{
    font-size: 20px;
    line-height: 28px;
    color: #fff;
    letter-spacing: -0.33px;
  }

  .loading-text{
    margin-top: 20px;
    font-size: 14px;
    line-height: 24px;
    color: #a5a5a5;
    letter-spacing: -0.27px;
  }

  .loading-progress {
    width: 80px;
    height: 80px;
  }
  .spinner {
    width: 80px;
    height: 80px;
    animation-iteration-count: infinite;
  }
  .loading{
    width: 80px;
    height: 80px;
    /*background: url(../assets/images/common/loading.png) no-repeat 0 0;*/
    background-size: cover;
    animation:box 1s steps(12) infinite;
  }
  @keyframes box {
    from {background-position:0 0}
    to   {background-position:-960px 0}
  }
</style>
